import { useAuth } from "../../state/hooks";
import { useDocumentTitle } from "../../utilities/useDocumentTitle";
import { TeammatesCard } from "./TeammatesCard";
import { TeamNameForm } from "./TeamNameForm";

export const TeamSettingsPage = () => {
  const { user, organization } = useAuth();
  useDocumentTitle("Team", "Settings");

  return (
    <div className="mx-auto flex w-full max-w-xl flex-col gap-4xl">
      <TeamNameForm organization={organization} />
      <TeammatesCard
        orgSlug={organization.slug}
        currentUserEmail={user.email}
      />
    </div>
  );
};
